import { graphql } from 'gatsby';
import React from 'react';

interface CardProps {
  block: {
    _template: string;
    css_class_name: string;
    hide_on_mobile: boolean;
    image: string;
    image_alt_text: string;
    open_in_new_tab: boolean;
    settings: {
      css_class_name: string;
    };
    src: string;
    text: string;
    title: string;
  };
  style?: React.CSSProperties;
}
/* 
  Lets use this for all kinds of cards.
*/
const Card: React.FC<CardProps> = ({ block, style }) => {
  const targetBlank = block.open_in_new_tab ? { target: '_blank' } : {};
  const cssClassName = block.settings ? block.settings.css_class_name : '';
  const responsiveClass = block.hide_on_mobile ? 'is-desktop' : '';

  return (
    <div
      className={`block ${block._template} ${cssClassName} ${responsiveClass}`}
      style={style}
    >
      <a
        href={block.src}
        className='general-card'
        {...targetBlank}
      >
        <div className='general-card__image'>
          <img
            src={block.image}
            alt={block.image_alt_text}
            loading='lazy'
          />
        </div>
        <div className='general-card__content'>
          <h4 className='general-card__title'>{block.title}</h4>
          {block.text ? (
            <p className='general-card__text'>{block.text}</p>
          ) : null}
          <svg
            className='arrow-icon'
            xmlns='http://www.w3.org/2000/svg'
            width='32'
            height='32'
            viewBox='0 0 32 32'
          >
            <g
              fill='none'
              strokeWidth='1.5'
              strokeLinejoin='round'
              strokeMiterlimit='10'
            >
              <circle
                className='arrow-icon--circle'
                cx='16'
                cy='16'
                r='15.12'
              />
              <path
                className='arrow-icon--arrow'
                d='M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98'
              />
            </g>
          </svg>
        </div>
      </a>
    </div>
  );
};

export default Card;

export const columnsCardFragment = graphql`
  fragment ColumnsCardFragment on ColumnsCardBlock {
    _template
    settings {
      ...SettingsFragment
    }
    hide_on_mobile
    title
    text
    image
    image_alt_text
    src
    open_in_new_tab
  }
`;
